<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>服务订单管理</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
          :model="filters"
        >

          <el-form-item label='订单号'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入订单号"
            >
              <el-button
                slot="append"
                v-on:click="handleSearch"
              >搜索</el-button>
            </el-input>
            <!-- <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出订单</el-button> -->
            <!-- <el-button
              @click="batchIn"
              type="success"
              size="small"
            >批量发货</el-button> -->
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="下单时间">
                <el-row>
                  <el-col :span="10">
                    <el-form-item prop="startTime">
                      <el-date-picker
                        type="date"
                        placeholder="选择开始日期"
                        v-model="filters.startTime"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>

                  <el-col :span="1">
                    <div style="display: inline-block;width:100%;text-align:center">-</div>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item prop="endTime">
                      <el-date-picker
                        type="date"
                        placeholder="选择结束日期"
                        v-model="filters.endTime"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-form-item>
            </el-col>
            <el-col
              :offset="1"
              :span="8"
            >
              <el-form-item label="订单状态">
                <el-select
                  v-model="filters.status"
                  clearable
                >
                  <el-option
                    label="待支付"
                    value="1"
                  ></el-option>
                  <el-option
                    label="待结单"
                    value="2"
                  ></el-option>
                  <el-option
                    label="待完成"
                    value="3"
                  ></el-option>
                  <el-option
                    label="申请退单中"
                    value="4"
                  ></el-option>
                  <el-option
                    label="待评价"
                    value="5"
                  ></el-option>
                  <el-option
                    label="已完成"
                    value="6"
                  ></el-option>
                  <el-option
                    label="已退单"
                    value="7"
                  ></el-option>
                  <el-option
                    label="已失效"
                    value="8"
                  ></el-option>
                  <el-option
                    label="系统关闭"
                    value="9"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="发单人信息:">
                <el-input
                  style="width: 200px;"
                  v-model="filters.userInfo"
                  placeholder="请输入发单人手机号或姓名"
                >
                </el-input>

              </el-form-item>
            </el-col>
            <el-col :span="8">

              <el-form-item label="接单人信息:">
                <el-input
                  style="width: 200px;"
                  v-model="filters.goodName"
                  placeholder="请输入接单人手机号或姓名"
                >
                </el-input>

              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="被服务人信息：">
                <el-input
                  style="width: 200px;"
                  v-model="filters.address"
                  placeholder="请输入被服务人手机号或姓名"
                >
                </el-input>

              </el-form-item>
            </el-col>

          </el-row>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          v-loading='tableDataLoading'
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="send_name"
            label="发单人姓名"
          >
          </el-table-column>

          <el-table-column
            prop="send_tel"
            label="发单人手机号"
          >
          </el-table-column>


          <el-table-column
            prop="username"
            label="被服务对象"
          >
          </el-table-column>


          <el-table-column
            prop="telephone"
            label="被服务对象手机号"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            :show-overflow-tooltip="true"
            label="时间区间"
          >
            <template slot-scope="scope">
              {{scope.row.begin_time}}-{{scope.row.end_time}}
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            :show-overflow-tooltip="true"
            label="服务天数"
          >
            <template slot-scope="scope">
              {{scope.row.service_day}}天
            </template>
          </el-table-column>
          <el-table-column
            prop="service_price"
            label="原始价格"
          >
          </el-table-column>

          <el-table-column
            prop="add_price"
            label="加价"
          >
          </el-table-column>

          <el-table-column
            prop="postage_money"
            label="服务地址"
          >
          <template slot-scope="scope">
              {{scope.row.province}}-{{scope.row.city}}-{{scope.row.district}}-{{scope.row.address_detail}}
            </template>
          </el-table-column>
          <el-table-column
            prop="type_name"
            label="服务类型"
          >

          </el-table-column>

          <el-table-column
            prop="take_name"
            label="接单人姓名"
          >
          </el-table-column>

          <el-table-column
            prop="take_tel"
            label="接单人手机号"
          >
          </el-table-column>

          <el-table-column
            prop="score"
            label="打分"
          >
          </el-table-column>

          <el-table-column
            prop="back_commend"
            label="退单理由"
          >
          </el-table-column>

          <el-table-column label="评价单">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                trigger="hover">
                <img style="max-height: 800px;max-width: 300px" :src="scope.row.judge_pic"/>
                <img slot="reference" :src="scope.row.judge_pic" :alt="scope.row.judge_pic" style="max-height: 50px;max-width: 130px">
              </el-popover>

            </template>
          </el-table-column>



          <el-table-column
            prop="status"
            :formatter="formatterStatus"
            label="状态"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="批量发货"
      :visible.sync="dialogBatchInVisible"
      width="40%"
    >

      <!-- <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="规格名称"
          prop='excelFile'
        >
          <el-input
            type="file"
            @change="getFile"
            v-model="form.excelFile"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="batchInPost()"
            :loading="batchInPostLoading"
          >发货</el-button>
        </el-form-item>
      </el-form> -->

      <form>
        <input
          type="file"
          @change="getFile($event)"
        >
        <el-button
          :loading="batchInPostLoading"
          class="el-button el-button--primary el-button--small"
          @click="batchInPost($event)"
        >提交</el-button>
      </form>
      <div style="color: red;">
        <div
          v-for="item in errMsg"
          v-bind:key="item"
        ><span>{{item}}</span><br /></div>
      </div>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../bus.js";
import API from "../api/api_user";
var _ = require("lodash");
export default {
  name: "serviceOrderList",
  created() {},

  data() {
    return {
      addExcelSnedLoading: false,
      errMsg: null,
      dialogBatchInVisible: false,
      batchInPostLoading: false,
      tableDataLoading: false,
      searchUserId: null,
      tableData1: [],
      addFormRule: {
        excelFile: [
          { required: true, message: "请选择Excel文件", trigger: "blur" }
        ]
      },
      form: {
        excelFile: null
      },
      file: null,
      filters: {
        address: null,
        title: null,
        status: null,
        startTime: null,
        endTime: null,
        status: null,
        userInfo: null,
        goodName: null
      },
      isCollapse: true,
      activeName: "second",
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    getFile(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },
    batchIn() {
      this.form.excelFile = null;
      this.file = null;
      this.dialogBatchInVisible = true;
    },
    batchInPost(event) {
      event.preventDefault();
      var that = this;
      if (this.file == null) {
        that.$message.error({
          showClose: true,
          message: "请先上传需要导入的excel",
          duration: 2000
        });
        return;
      } else {
        that.addExcelSnedLoading = true;
        that.batchInPostLoading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        var ss = this.file.name
          .substr(this.file.name.lastIndexOf("."))
          .toUpperCase(); //得到的是后缀名,且转换为大写
        if (ss == ".XLS") {
          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };

          API.import_car_info(formData, config)
            .then(
              function(result) {
                that.batchInPostLoading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (result.result.list.length == 0) {
                    that.dialogBatchInVisible = false;
                    that.$message.success({
                      showClose: true,
                      message: "发货成功",
                      duration: 1500
                    });
                    that.search();
                  } else {
                    that.errMsg = result.result.list;
                  }
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "请求失败，请检查文件格式和内容是否符合要求",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.batchInPostLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.batchInPostLoading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          this.errMsg = ["格式错误"];
          return;
        }
      }
    },

    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/item_order_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.title) {
        url = url + "&keyword=" + that.filters.title;
      }
      if (that.filters.goodName) {
        url = url + "&goodName=" + that.filters.goodName;
      }
      if (that.filters.userInfo) {
        url = url + "&userInfo=" + that.filters.userInfo;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.address) {
        url = url + "&address=" + that.filters.address;
      }
      top.location.href = url;
    },

    formatterStatus(row, column) {
      if (row.status == 1) {
        return "待支付";
      } else if (row.status == 2) {
        return "待接单";
      } else if (row.status == 3) {
        return "待完成";
      } else if (row.status == 4) {
        return "申请退单中";
      } else if (row.status == 5) {
        return "待评价";
      } else if (row.status == 6) {
        return "已完成";
      } else if (row.status == 7) {
        return "已退单";
      } else if (row.status == 8) {
        return "已失效";
      } else if (row.status == 9) {
        return "已关闭";
      }
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },
    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm("确定禁用该用户吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: status
            };
            API.status_normal_user(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "禁用成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 3) {
        let that = this;
        this.$confirm("确定取消该订单吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
            };
            API.apply_return(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "取消成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定发货吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.send_good(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "发货成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.goodName) {
        params.takeInfo = that.filters.goodName;
      }
      if (that.filters.userInfo) {
        params.userInfo = that.filters.userInfo;
      }
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.address) {
        params.otherInfo = that.filters.address;
      }
      that.tableDataLoading = true;
      API.service_order_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {

                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.main_content .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 10px !important;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceOrderList.vue